module.exports = __webpack_public_path__ + "img/AzadGulladin-MeziZhmara.ae15f55d.jpg";